/** @jsxImportSource @emotion/react */

import { COLORS } from '@btime/constants'
import { css } from '@emotion/react'
import GoogleMap from 'google-map-react'
import React, { forwardRef } from 'react'

import { getPublicUrl } from '../../utils/env/env'
import { mapTheme } from './mapTheme'
import { useEnv } from '../../utils/contexts/EnvContext'
import Button from '../actions/Button'
import FlexGrid from '../structure/FlexGrid'

const Map = forwardRef(
  (
    { disableFullScreen, children, route, defaultCenter, defaultZoom, height, noLock, enableStreetView, ...props },
    ref
  ) => {
    const env = useEnv()
    const [visible, setVisible] = React.useState(noLock ? true : false)
    const onShowMap = () => setVisible(true)

    const style = css`
      height: ${height || '12rem'};
      width: 100%;
      background: url(${getPublicUrl(env, 'blur-map.png')});
      background-repeat: no-repeat;
      background-size: cover;
      background-position: center;
    `

    return (
      <div css={style}>
        {!visible ? (
          <FlexGrid>
            <Button onClick={onShowMap} color={COLORS.dark3}>
              {'Mostrar mapa'}
            </Button>
          </FlexGrid>
        ) : (
          <GoogleMap
            onGoogleApiLoaded={({ map, maps }) => {
              if (!route) return

              const linePath = route.map(item => {
                return { lat: item.latitude, lng: item.longitude }
              })

              const polyline = new maps.Polyline({
                path: linePath,
                geodesic: true,
                strokeColor: '#FF0000',
                strokeOpacity: 1.0,
                strokeWeight: 20
              })

              polyline.setMap(map)
            }}
            ref={ref}
            bootstrapURLKeys={{ key: env.REACT_APP_GOOGLE_API_KEY }}
            defaultCenter={defaultCenter}
            defaultZoom={defaultZoom || 12}
            options={{
              styles: mapTheme,
              fullscreenControl: !disableFullScreen,
              streetViewControl: !!enableStreetView,
              restriction: {
                latLngBounds: {
                  north: 90,
                  south: -90,
                  east: 179,
                  west: -179
                },
                strictBounds: false
              }
            }}
            {...props}
          >
            {children}
          </GoogleMap>
        )}
      </div>
    )
  }
)

export default Map
